import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const SuperUserButton = props => (
  <button className={Styles.superUserBtn} onClick={props.onClick}>
    View as Super User
  </button>
)

SuperUserButton.defaultProps = {
  onClick: () => { },
}

SuperUserButton.propTypes = {
  onClick: PropTypes.func,
}

export default SuperUserButton
